<section class="radio-button-input-wrapper">
  <label [for]="data.radioButtonGroupId"
    ><gc-text [variant]="'body'">{{ data.label }}</gc-text></label
  >
  <div class="radio-button-container">
    @for (radioButton of data.radioButtons; track radioButton.value) {
      <gc-radio-button
        [checked]="radioButton.isChecked"
        [label]="radioButton.label"
        [value]="radioButton.value"
        [name]="data.radioButtonGroupId"
        (changed)="checkedValue.emit($event)"
      />
    }
  </div>
  @if (optionsButton) {
    <app-options-button [isDone]="data.isDone" [id]="data.id" />
  }
</section>
